import React from 'react';

interface TechnologyListProps {
  technologies: string[];
}

const TechnologyList: React.FC<TechnologyListProps> = ({ technologies }) => {
  return (
    <div className="bg-gray-50 rounded-xl shadow-lg p-8 max-w-2xl mx-auto border border-gray-200">
      {/* Encabezado con borde decorativo */}
      <div className="mb-8 relative">
        <h3 className="text-2xl font-semibold text-navy-900 tracking-wide">
          <span className="bg-white px-4 py-2 rounded-lg inline-flex items-center shadow-sm">
            <span className="w-3 h-3 bg-navy-700 rounded-full mr-3 ring-2 ring-navy-300"></span>
            Tecnologías Principales
          </span>
        </h3>
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-navy-300 via-gray-50 to-navy-300"></div>
      </div>

      {/* Lista con efecto de tarjeta */}
      <ul className="space-y-3">
        {technologies.map((tech, index) => (
          <li
            key={index}
            className="group flex items-center bg-white p-4 rounded-lg 
                     hover:bg-gray-100 transition-all duration-300
                     hover:shadow-md hover:-translate-y-0.5 cursor-default
                     border border-navy-100"
          >
            {/* Ícono dinámico */}
            <span className="w-2 h-2 bg-navy-600 rounded-full mr-4 
                            group-hover:bg-navy-800 group-hover:ring-2 
                            group-hover:ring-navy-300 transition-all"></span>
            
            {/* Texto con énfasis corporativo */}
            <span className="text-lg font-medium text-navy-900">
              {tech}
            </span>
          </li>
        ))}
      </ul>

      {/* Nota al pie discreta */}
      <div className="mt-6 text-center">
        <p className="text-sm text-navy-800 italic">
          Stack tecnológico certificado y actualizado
        </p>
      </div>
    </div>
  );
};

export default TechnologyList;